import { created } from './created';
import { id } from './id';
import { size } from './size';
import { tags } from './tags';

export const columns = [id, tags, size, created];
